<script setup lang="ts">
import BoNoticeDocVarField from './BoNoticeDocVarField.vue';
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead recipient-mode="registered_bo" />
    <p class="doc-p">
      Pursuant to subsection 60C(5) of the CA 2016, we have reasonable grounds to believe that the particulars of your
      beneficial ownership information stated in the register of beneficial owners of the Company might be incorrect.
      Please confirm whether or not the particulars
      (<BoNoticeDocVarField field-key="relevant_particulars" />)
      are correct within 30 days from the date of this notice.
    </p>
    <p class="doc-p">
      <b>2</b><br />
      If the particulars are incorrect, please state the correct particulars.
    </p>
    <p class="doc-p"><b>3</b><br />Please include the following declaration as part of your reply:</p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I/We hereby confirmed that the facts and information stated in this letter are true and to the best of my/our knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>4</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO06" designation-key="signer_designation_BO06" />
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
